import { Icon } from '../Icon'
import { SortDirections } from '@dtx-company/true-common/src/types/generic'
import { TableCellBase, TableCellIconBase } from './styles'
import { TableCellProps, Types } from '../../..'
import { useEffect, useRef, useState } from 'react'
import ArrowDown from '../../../static/icons/sort_downward.svg'
import ArrowUp from '../../../static/icons/sort_upward.svg'
import ArrowUpDefault from '../../../static/icons/sort_default.svg'
import gridIcon from '../../../static/icons/grid.svg'
import listIcon from '../../../static/icons/list.svg'
import menuIcon from '../../../static/icons/three-dots.svg'

const actionIcons: Record<Types, string> = {
  menu: menuIcon,
  grid: gridIcon,
  list: listIcon,
  sort: ''
}

export const TableCell = ({
  children,
  component = 'td',
  fontVariant = 'lg',
  onClick,
  type,
  initialSortDirection = SortDirections.ASC,
  controlledSortDirection = '',
  iconProps = {
    src: undefined,
    alt: undefined,
    height: undefined,
    width: undefined,
    display: undefined,
    button: false
  },
  displaySortIcon = true,
  ...rest
}: TableCellProps): JSX.Element => {
  const isMounted = useRef(false)
  const [sortDirection, setSortDirection] = useState(initialSortDirection)
  const [sortIcon, setSortIcon] = useState(ArrowUpDefault)

  useEffect(() => {
    switch (controlledSortDirection) {
      case SortDirections.ASC:
        setSortIcon(ArrowUp)
        break
      case SortDirections.DSC:
        setSortIcon(ArrowDown)
        break
      default:
        setSortIcon(ArrowUpDefault)
    }
  }, [controlledSortDirection])

  const { src, alt, height, width, display, button, ...iconRest } = iconProps
  const handleClick: TableCellProps['onClick'] = e => {
    const direction = sortDirection === SortDirections.ASC ? SortDirections.DSC : SortDirections.ASC
    if (type === 'sort') {
      setSortDirection(direction)
    }
    if (onClick) onClick(e, direction)
  }

  useEffect(() => {
    isMounted.current = true

    return () => {
      isMounted.current = false
    }
  }, [])

  useEffect(() => {
    if (controlledSortDirection && controlledSortDirection !== sortDirection && isMounted.current)
      setSortDirection(controlledSortDirection)
  }, [controlledSortDirection, sortDirection])

  return (
    <TableCellBase
      as={component}
      onClick={handleClick}
      hasIcon={!!src}
      type={type}
      fontVariant={fontVariant}
      aria-label="table-cell"
      {...rest}
      pr={type === 'sort' ? 0 : '25px'}
    >
      {type && type !== 'sort' && (
        <TableCellIconBase {...iconRest}>
          <Icon
            src={actionIcons[type]}
            alt={type}
            button={true}
            height={height}
            width={width}
            display={display}
          />
        </TableCellIconBase>
      )}
      {children}
      {src && (
        <TableCellIconBase {...iconRest}>
          <Icon
            src={src}
            alt={alt}
            button={button}
            height={height}
            width={width}
            display={display}
          />
        </TableCellIconBase>
      )}
      {type === 'sort' && displaySortIcon && (
        <Icon
          src={sortIcon}
          alt={`sort-${sortDirection}`}
          height="15px"
          width="20px"
          marginLeft="5px"
        />
      )}
    </TableCellBase>
  )
}
